import classNames from 'classnames'
import { useId } from 'react'
import styles from './Badge.module.css'
import { BadgeVariant } from './PointBadge'

interface Props {
  variant: BadgeVariant
  text: string | number
  className?: string
  id?: string
}

export const Badge = (props: Props) => {
  const id = useId()
  return (
    <div className={classNames(styles.badge, styles[props.variant], props.className)} id={props.id ?? id}>
      {props.text}
    </div>
  )
}
